import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CurrentLanguageProvider, SessionDataProvider} from '@synisys/idm-session-data-provider-api-js';
import {
	CurrentLanguageManager,
	LoginGuard,
	LoginPagePreventionGuard,
	MainOnlineProvidersModule,
	SessionDataProviderImpl
} from '@synisys/idm-ui-shell';
import {AppComponent} from './app.component';
import {FlashMessagesService} from "angular2-flash-messages";
import {appRoute} from './app.routing';
import {AsyncLocalStorageModule} from "angular-async-local-storage";
import {HttpUserService, UserService} from "@synisys/idm-um-client-js";
import {
	ActionService,
	HttpActionService,
	HttpProcessService,
	HttpStateService,
	ProcessService,
	StateService
} from '@synisys/idm-workflow-service-client-js';
import {IGNORE_AUTH_TOKEN, RequestPatternModel} from '@synisys/skynet-store-authentication-impl';
import {CacheInterceptor} from "./shared/interceptor/cache-interceptor";
import {EXCLUDED_FOR_LOADING_URLS} from "@synisys/idm-ui-shell/app/services/loading.interceptor";
import {CustomPreloadingStrategyService} from "./shared/custom-preloading-strategy.service";
import {MeTreeShakingInterceptor} from "./shared/interceptor/me-tree-shaking-interceptor";
import {PortfolioInterceptor} from "./shared/interceptor/portfolio.interceptor";
import {CustomLoginGuard} from "./services/custom-login-guard.service";
import {AgraDataService} from "./services/agra-data.service";
import {BeneficiaryInterceptor} from "./shared/interceptor/beneficiary.interceptor";

// import {ObserveHelperService} from "@synisys/agra-dynamic-forms-controls/app/controls/shared/observe/observe-helper.service";

@NgModule({
	imports: [
		BrowserAnimationsModule,
		HttpClientModule,
		appRoute,
		// OnlineProvidersModule,
		AsyncLocalStorageModule,
		MainOnlineProvidersModule
	],
	declarations: [
		AppComponent,
	],
	providers: [
		CustomPreloadingStrategyService,
		LoginPagePreventionGuard,
		LoginGuard,
		CustomLoginGuard,
		AgraDataService,
		SessionDataProviderImpl,
		CurrentLanguageManager,
		FlashMessagesService,

		{provide: CurrentLanguageProvider, useExisting: SessionDataProviderImpl},
		{provide: SessionDataProvider, useExisting: SessionDataProviderImpl},

		{provide: UserService, useClass: HttpUserService},
		{provide: ProcessService, useClass: HttpProcessService},
		{provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true},
		{provide: HTTP_INTERCEPTORS, useClass: PortfolioInterceptor, multi: true},
		{provide: HTTP_INTERCEPTORS, useClass: BeneficiaryInterceptor, multi: true},
		{provide: HTTP_INTERCEPTORS, useClass: MeTreeShakingInterceptor, multi: true},
		{provide: StateService, useClass: HttpStateService},
		{provide: ActionService, useClass: HttpActionService},

		{provide: EXCLUDED_FOR_LOADING_URLS, useValue: ['notifications/emitter', 'icons/core.svg']},

		// ObserveHelperService,
		{provide: IGNORE_AUTH_TOKEN, useValue:  new RequestPatternModel('GET', /(agra\/me)$/), multi: true},
		{provide: IGNORE_AUTH_TOKEN, useValue:  new RequestPatternModel('GET', RegExp('resetPassword', 'i')), multi: true},
		{provide: IGNORE_AUTH_TOKEN, useValue:  new RequestPatternModel('POST', RegExp('resetPassword', 'i')), multi: true},
		{provide: IGNORE_AUTH_TOKEN, useValue:  new RequestPatternModel('PUT', RegExp('resetPassword', 'i')), multi: true},
		{provide: IGNORE_AUTH_TOKEN, useValue:  new RequestPatternModel('PATCH', RegExp('resetPassword', 'i')), multi: true}
	],
	bootstrap: [AppComponent],
})
export class AppModule {
}
